package ai.jessie.web

import com.varabyte.kobweb.core.init.InitKobweb
import com.varabyte.kobweb.core.init.InitKobwebContext
import kotlinx.browser.document
import kotlinx.browser.window
import org.w3c.dom.Element
import org.w3c.dom.HTMLAnchorElement
import org.w3c.dom.events.MouseEvent

// A plain anchor reloads the whole exported page, which blanks the screen on every click. Internal
// page links go through the router instead; server endpoints, downloads and new tabs stay native.
@InitKobweb
fun initLinkRouting(ctx: InitKobwebContext) {
    document.addEventListener(
        "click",
        { event ->
            routablePath(event as MouseEvent)?.let {
                event.preventDefault()
                ctx.router.navigateTo(it)
            }
        },
    )
}

/** The path, query and fragment to route in place, or null when the browser should navigate. */
internal fun routablePath(event: MouseEvent): String? {
    val anchor = (event.target as? Element)?.closest("a[href]") as? HTMLAnchorElement
    val modified = event.metaKey || event.ctrlKey || event.shiftKey || event.altKey
    return anchor
        ?.takeIf {
            !event.defaultPrevented &&
                event.button == 0.toShort() &&
                !modified &&
                it.origin == window.location.origin &&
                (it.target.isEmpty() || it.target == "_self") &&
                !it.hasAttribute("download") &&
                !it.getAttribute("href").orEmpty().startsWith("#") &&
                !it.pathname.startsWith("/api/")
        }
        ?.let { it.pathname + it.search + it.hash }
}
